module.exports = __webpack_public_path__ + "static/img/honor-img.2d082cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/honor-img.png
// module id = AFzz
// module chunks = 0